module.exports = __webpack_public_path__ + "img/DE01882.8b01d06c.png";